// extracted by mini-css-extract-plugin
export default {"stopSearch":"StopSearch_stopSearch__kk+8N","result":"StopSearch_result__9JyXt","indicator":"StopSearch_indicator__61B-k"};